const app = angular.module('CustomerSupport');

app.controller(
  'CustomerSupportController',
  function (
    CustomerSupportService,
    $scope,
    $http,
    $timeout,
    $document,
    $filter,
    $window
  ) {
    $scope.resetEmail = function () {
      $scope.loading = false;
      $scope.typeOfAssistanceInvalid = true;
      $scope.loading = false;
    };

    $document.on('track.siteCatalystBeforeSend', function (e, data) {
      if (tracking_data['merch-link']) {
        tracking_data.nav = tracking_data['merch-link'];
      }
      if (tracking_data['carousel-link']) {
        tracking_data.more_results = tracking_data.carousel_interaction =
          tracking_data['carousel-link'];
      }
      if (tracking_data['carousel-link']) {
        tracking_data.nav = tracking_data['carousel-link'];
      }
      $.extend(data.pageTrackingVariables);
    });

    $scope.loadCountries = () =>
      CustomerSupportService.getCountries().then(function (response) {
        $scope.countries = response.data;
        const filtered = $filter('filter')($scope.countries, {
          id: countryCode,
        });
        const defaultCountry = $filter('filter')($scope.countries, {
          id: 'USA',
        })[0];
        $scope.country = filtered.length === 0 ? defaultCountry : filtered[0];
        $scope.updateCountryCode();
      });

    $scope.updateCountryCode = function () {
      $scope.countryCode = $scope.country.id;
      $scope.selectedCountryIndirect =
        typeof indirectCountries !== 'undefined' &&
        indirectCountries.indexOf($scope.countryCode) !== -1;
      $scope.localOfficeCountry = t('your_local_office', {
        country: $scope.country.name,
      });
    };

    $scope.init = (fromChat) => {
      $scope.questions = [];
      $scope.countryHasPhone = [];
      $scope.countryHasMultiplePhones = [];
      $scope.customer_support = [];
      $scope.sections = [];
      $scope.sections['mail'] = false;
      $scope.sections['phone'] = currentSite.isiStock;
      $scope.thanks = false;
      $scope.error = false;
      $scope.fromChat = fromChat;
      $scope.assistingType = { type: 'q', valid: false };
      $scope.resetEmail();
      $scope.loadCountries();
      $scope.language = languageCode;
      $scope.isAnonymous = customerNumber === '0';
    };

    $scope.toggleSection = function (section) {
      if (section === 'mail' && !$scope.sections[section]) {
        $scope.sections['phone'] = false;
      }
      if (section === 'phone' && !$scope.sections[section]) {
        $scope.sections['mail'] = false;
      }

      if (!$scope.countryHasPhone[$scope.countryCode] && section === 'phone') {
        $scope.openLocalOfficeInfo();
      } else {
        $scope.sections[section] = !$scope.sections[section];
      }
    };

    $scope.toggleAnswer = function (index) {
      const len = $scope.questions.length;
      for (let i = 0, end = len - 1; i < end; i++) {
        if (index !== i) {
          $scope.questions[i] = false;
        }
      }

      $scope.questions[index] = !$scope.questions[index];
    };

    $scope.addQuestion = () => $scope.questions.push(false);

    $scope.addCountryHasPhone = (country, hasPhone) =>
      ($scope.countryHasPhone[country] = hasPhone);

    $scope.addCountryHasMultiplePhones = (country, hasPhone) =>
      ($scope.countryHasMultiplePhones[country] = hasPhone);

    $scope.sendAnotherMessage = () => ($scope.emailSent = false);

    $scope.trackSendEmail = () => {
      window.dataLayer.push({
        event: 'form_interaction',
        event_name: 'form_submit',
        form_name: 'uni_contact_us_form',
        form_id: 'new_customer_form', // HTML ID for form
        form_destination: '/customer-support/send-email-or-case', // url for form submission
        form_submit_text: 'Submit',
      });
    };

    $scope.sendEmail = function (data) {
      const form = $scope.emailForm;
      s.pageName = 'CustomerSupport';
      s.linkTrackVars = 'pev2';
      s.pev2 = 'ContactUs_SendEmail';
      s.events = 'event79';
      s.linkTrackEvents = s.events;
      s.tl(true, 'o', 'Contact');

      $scope.loading = true;
      $scope.error = false;
      const fd = new FormData();
      const cs = $scope.customer_support;

      fd.append('comments', cs['comments']);
      fd.append('email', cs['email']);
      fd.append('g-recaptcha-response', data);
      fd.append('name', cs['name']);
      fd.append('assisting_type', $scope.assistingType.data.id);
      fd.append('country_code', $scope.countryCode);
      fd.append('from_chat', $scope.fromChat);
      if (currentSite.isiStock) {
        const omniEvent = 'event150';
      } else {
        if (cs['company']) {
          fd.append('company', cs['company']);
        }
        if (cs['telephone']) {
          fd.append('telephone', cs['telephone']);
        }
        if ($scope.attachment && $scope.attachment.fileAttached) {
          fd.append('file_data', $scope.attachment.data);
          fd.append('file_name', $scope.attachment.name_without_extension);
        }
      }

      $scope.trackSendEmail();

      CustomerSupportService.sendEmail(fd)
        .success(function () {
          $scope.thanks = true;
          if ($scope.customer_support['customShow'] === 'member_updates') {
            $window.self.close();
          }
          $scope.customer_support['assistingType'] = null;
          $scope.customer_support['comments'] = null;
          $scope.customer_support['reason'] = null;
          $scope.$broadcast('form-sent');
          form.$setPristine();
          form.$setUntouched();
          $scope.emailSent = true;
          return $timeout(function () {
            $scope.thanks = false;
          }, 8000);
        })
        .error(() => ($scope.error = true))
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.attachmentChanged = (file) => ($scope.attachment = file);

    $scope.openLocalOfficeInfo = function () {
      return $timeout(function () {
        $scope.showLocalOfficeInfo = true;
        $document.one('modal.close', () => $scope.closeLocalOfficeInfo());
      });
    };

    $scope.closeLocalOfficeInfo = () => ($scope.showLocalOfficeInfo = false);

    $scope.assistingTypeChanged = function (item) {
      $scope.assistingType = item;
    };
  }
);
//track
